import React from "react";
import styled from "styled-components";

import { RealtimeSalesSection } from "./sales-section";
import { RealtimeMembersSection } from "./members-section";

export const RealtimeDashboard = () => {
  return (
    <Container>
      <RealtimeSalesSection />
      <RealtimeMembersSection />
    </Container>
  );
};

const Container = styled.article`
  width: 100%;
`;
